import { createContext, useContext } from 'react';
import type { OrganizationSetupStepKey } from '@brimo/shared';
import type { SetupOrganization, StepAction } from './types';
import type { WizardSegment } from './wizardSteps';

export interface WizardNav {
  wizard: SetupOrganization;
  /** Opens another step without touching its status. */
  go: (segment: WizardSegment) => void;
  /** `POST /setup/organization/steps/:key` with the action, then the next step. Rejects with the API error. */
  complete: (key: OrganizationSetupStepKey, action: StepAction, next: WizardSegment) => Promise<void>;
  /** `POST /setup/organization/finish`, then the checklist (Admin 11). */
  finish: () => Promise<void>;
}

export const WizardContext = createContext<WizardNav | null>(null);

export function useWizardNav(): WizardNav {
  const value = useContext(WizardContext);
  if (value === null) throw new Error('useWizardNav() needs the AdminWizard');
  return value;
}
